import { page1, page2 } from './fakeData';

const createMock = (success, delay = 500) =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve(success);
    }, delay);
  });

const getPermission = () => {
  return createMock({ userId: 1 }, 1000);
};

const getDirections = () => {
  return createMock([
    { id: 'game_dev', name: 'Games Dev' },
    { id: 'inf', name: 'Infrastructure' },
  ]);
};

const getEventTypes = () => {
  return createMock([
    { id: 'client_release', name: 'client_release' },
    { id: 'server_release', name: 'server_release' },
    { id: 'config_deploy', name: 'config_deploy' },
    { id: 'event_split', name: 'event_split' },
  ]);
};

const getResponsible = () => {
  return createMock([
    { id: 'user.vetal', name: 'user.vetal' },
    { id: 'user.vetal2', name: 'user.vetal2' },
    { id: 'user.vetal3', name: 'user.vetal3' },
    { id: 'user.vetal4', name: 'user.vetal4' },
  ]);
};

const getGames = () => {
  return createMock([
    { id: 'SS', name: 'SS' },
    { id: 'SE', name: 'SE' },
  ]);
};

const getPlatforms = () => {
  return createMock([
    {
      id: 'android',
      name: 'android',
    },
    {
      id: 'iphone',
      name: 'iphone',
    },
  ]);
};

const getVersions = () => {
  return createMock([
    {
      id: '1.0.0',
      name: '1.0.0',
    },
  ]);
};

const createEvent = () => {
  return createMock();
};

const updateEvent = () => {
  return createMock();
};

const getEvent = id => {
  if (id === '0') {
    return Promise.reject();
  }
  return createMock({
    id,
    dateTime: '2019-08-07 11:23:55',
    direction: 'game_dev',
    eventType: 'test',
    game: ['SS'],
    platform: ['android'],
    description: 'test - description',
    responsible: 'user.vetal',
    author: 'user.vetal',
    createdAt: '2019-07-07',
    payload: {
      link: 'https://www.google.com',
      appVersion: '12.0',
    },
  });
};

const getFormDirections = () => {
  return createMock([{ id: 'game_product', name: 'Game Product' }]);
};

const getFormEvents = () => {
  return createMock([
    { id: 'client_release', name: 'Client Release' },
    { id: 'server_release', name: 'Server Release' },
    { id: 'config_deploy', name: 'Config Deploy' },
    { id: 'event_split', name: 'Event Split' },
  ]);
};

const getFormGames = () => {
  return createMock([
    { id: 'era', name: 'Slots Era' },
    { id: 'holdem', name: 'Holdem' },
    { id: 'infinity', name: 'Infinity Slots' },
    { id: 'slotsontour', name: 'Slots On Tour' },
    { id: 'scatter', name: 'Scatter Slots' },
  ]);
};

const getFormPlatforms = () => {
  return createMock([
    { id: 'amazon', name: 'Amazon' },
    { id: 'android', name: 'Android' },
    { id: 'fb', name: 'FB' },
    { id: 'ios', name: 'iOS' },
    { id: 'windows', name: 'Windows' },
  ]);
};

const getFormResponsible = () => {
  return createMock([
    { id: 'bob', name: 'bob' },
    { id: 'alice', name: 'alice' },
    { id: 'dmitrij.maslov', name: 'dmitrij.maslov' },
    { id: 'roman.vasilev', name: 'roman.vasilev' },
    { id: 'dimooon', name: 'dimooon' },
  ]);
};

const getFormVersions = () => {
  return createMock([
    { id: '1.1', name: '1.1' },
    { id: '1.2', name: '1.2' },
    { id: '1.3', name: '1.3' },
    { id: '1.4.1', name: '1.4.1' },
    { id: '2.0', name: '2.0' },
    { id: '3.0', name: '3.0' },
  ]);
};

const getEvents = params => {
  const { page } = params;
  const pages = page === 1 ? page1 : page2;
  return createMock(pages);
};

export default {
  getPermission,
  getDirections,
  getEventTypes,
  getResponsible,
  getGames,
  getPlatforms,
  getVersions,
  createEvent,
  updateEvent,
  getEvent,
  getEvents,
  getFormDirections,
  getFormEvents,
  getFormGames,
  getFormPlatforms,
  getFormResponsible,
  getFormVersions,
};
